export const FORM_IDENTIFIER = 'app/FormFormPage';

export const INIT = 'app/FormFormPage/INIT';
export const INIT_SUCCESS = 'app/FormFormPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/FormFormPage/INIT_FAILED';

export const SAVE = 'app/FormFormPage/SAVE';
export const SAVE_SUCCESS = 'app/FormFormPage/SAVE_SUCCESS';
export const SAVE_FAILED = 'app/FormFormPage/SAVE_FAILED';
